/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminDisableOrgMemberOptions, AdminDisableOrgMemberResponses } from '../../models/AdminDisableOrgMember'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Disable Org Member
 * {@link /admin/org/:org_id/member/:user_id/disable}
 */
export function adminDisableOrgMember<ThrowOnError extends boolean = true>(options: Options<AdminDisableOrgMemberOptions, ThrowOnError>): Promise<UnwrappedResult<AdminDisableOrgMemberResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/org/{org_id}/member/{user_id}/disable', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminDisableOrgMemberResponses, ThrowOnError>>
}
